<template>
  <ClientOnly>
    <Transition
      name="stick-scroll"
      :enter-active-class="$style['stick-scroll']"
      :leave-active-class="$style['stick-scroll']"
      :enter-to-class="$style['stick-scroll-enter-to']"
      :enter-from-class="$style['stick-scroll-enter-from']"
      :leave-to-class="$style['stick-scroll-leave-to']"
      :leave-from-class="$style['stick-scroll-leave-from']">
      <div
        v-if="stickyActive"
        :class="[$style['sticky-container'],
                 { [$style['sticky-container--show-on-desktop']]: props.showOnDesktop }]">
        <slot />
      </div>
    </Transition>
  </ClientOnly>
</template>
<script setup lang="ts">
const props = defineProps<{
  testElement: HTMLElement // Element to test wether it is in viewport or not
  triggerHideElement: HTMLElement // Element to test wether the testElement should be hidden
  showOnDesktop?: boolean
}>()

const { stickyActive } = useStickOnScroll()
const scrollListener: Ref<any> = ref(null)

const onScroll = () => {
  if (!props.testElement) { return }
  stickyActive.value = props.testElement.getBoundingClientRect().y < 0 && props.triggerHideElement.getBoundingClientRect().y > window.innerHeight
}

const init = () => {
  if (!scrollListener.value) {
    scrollListener.value = window.addEventListener('scroll', onScroll, { passive: true })
  }
}

onMounted(init)
onActivated(init)

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
  scrollListener.value = null
  stickyActive.value = false
})
onDeactivated(() => {
  window.removeEventListener('scroll', onScroll)
  scrollListener.value = null
  stickyActive.value = false
})

</script>
<style lang="scss" module>

.sticky-container {
  width: 100%;
  background-color: $white;
  position: fixed;
  align-items: center;
  bottom: 0;
  left: 0;
  z-index: z-index(modal) - 1;
  box-shadow: $box-shadow-large;
  border-top: 1px solid $grey-lightest;
  padding-bottom: env(safe-area-inset-bottom);

  @media (min-width: #{$breakpoint-tablet}) {
    display: none;
    pointer-events: none;
  }

  &--show-on-desktop {
    @media (min-width: #{$breakpoint-tablet}) {
      display: flex;
      pointer-events: auto;
    }
  }
}

.stick-scroll {
  transition: transform $transition-time-slower $transition-easing;
}

.stick-scroll-enter-to,
.stick-scroll-leave-from {
  transform: translateY(0);
}

.stick-scroll-enter-from,
.stick-scroll-leave-to {
  transform: translateY(100%);
}
</style>
